import _ from "lodash"

import { DiscountId } from "shared/hubrise/ids"
import * as Discount from "shared/hubrise/utils/Discount"

import { DiscountPricing, IDiscount } from "../models"

import type { Change, OperationContext } from "./types"

export type DiscountOperations = {
  add(insertAfter: IDiscount | undefined, values: Pick<IDiscount, "name">): IDiscount
  delete(id: DiscountId): void
  move(discount: IDiscount, newPosition: number): void
  update<TField extends keyof IDiscount>(
    id: DiscountId,
    fieldName: TField,
    value: IDiscount[TField],
    options?: { collapse?: boolean },
  ): void
  updatePricing(id: DiscountId, pricing: DiscountPricing, options?: { collapse?: boolean }): void
}

export default ({ catalog, pushState }: OperationContext): DiscountOperations => ({
  add(insertAfter, values) {
    const { newCatalog, discount } = Discount.add(catalog, insertAfter, values)
    pushState(newCatalog, { model: "discount", operation: "add" })
    return discount
  },

  delete(id) {
    const newCatalog = Discount.doDelete(catalog, id)
    pushState(newCatalog, { model: "discount", operation: "delete", id })
  },

  move(discount, newPosition) {
    const newCatalog = Discount.move(catalog, discount, newPosition)
    const change: Change = { model: "discount", operation: "move", id: discount.id }
    pushState(newCatalog, change, (previousChange) => _.isEqual(previousChange, change))
  },

  update(id, fieldName, value, { collapse = true } = {}) {
    const newCatalog = Discount.update(catalog, id, fieldName, value)
    const change: Change = {
      model: "discount",
      id,
      operation: "update",
      fieldName,
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },

  updatePricing(id, pricing, { collapse = true } = {}) {
    const newCatalog = Discount.updatePricing(catalog, id, pricing)
    const change: Change = {
      model: "discount",
      id,
      operation: "update",
      fieldName: "pricing",
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },
})
